import type { CustomFieldDefinition } from '../../orders/api/intakeApi'

/** A field plus a stable client-only id so drag-and-drop can track it across reorders/edits. */
export type WorkingField = CustomFieldDefinition & { __uid: string }

export const makeUid = () =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `f_${Date.now()}_${Math.random().toString(36).slice(2)}`

export function toWorkingFields(fields: CustomFieldDefinition[] | null | undefined): WorkingField[] {
  return (fields ?? []).map((f) => ({ ...f, __uid: makeUid() }))
}

/** Strip the client-only __uid and re-stamp `order` from array position. */
export function fromWorkingFields(fields: WorkingField[], startOrder = 0): CustomFieldDefinition[] {
  return fields.map(({ __uid, ...rest }, i): CustomFieldDefinition => {
    void __uid
    return { ...rest, order: startOrder + i }
  })
}

export function newWorkingField(order: number): WorkingField {
  return {
    __uid: makeUid(),
    key: `field_${Date.now()}`,
    type: 'text',
    label: '',
    order,
  }
}
